import { params } from "./params";

export const environment = {
  ...params,
  production: true,
  fullUrl: "https://it-era.dev",
};
